<style lang="scss">
  .multiselect__tags {
    max-height: none;
    background-color: transparent !important;
    padding: 0px !important;
  }

  .multiselect__content {
    display: block !important;
  }
</style>

<template>
  <BModal
    id="modal-config-mail"
    modal-class="modal-no-header-no-footer"
    ref="modal-config-mail"
    size="md"
    hide-header="hide-header"
    hide-footer="hide-footer"
  >
    <template slot="default">
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="close()"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title align-items-center text-center">
        {{ __('Configurações') }}
      </h4>
      <form
        class="px-20px"
        method="post"
        @submit.prevent="save()"
      >
        <div class="form-group">
          <label>{{ __('Título interno') }}</label>
          <!-- eslint-disable-->
          <input
            class="form-control"
            id="mail-title"
            type="text"
            :placeholder="__('Utilizado para identificar seu e-mail dentro do Salesflow')"
            v-model="mail.title"
            required="required"
          >
        </div>
        <div v-if="errors.title">
          <p class="text-danger">
            {{ errors.title[0] }}
          </p>
        </div>
        <div class="form-group">
          <label>{{ __('Assunto do e-mail') }}</label>
          <input
            class="form-control"
            type="text"
            v-model="mail.subject"
            :placeholder="__('Assunto')"
            required="required"
          >
        </div>
        <div class="form-group">
          <label>{{ __('Nome do remetente') }}</label>
          <input
            class="form-control"
            type="text"
            v-model="mail.from_name"
            :placeholder="__('Nome')"
            required="required"
          >
          <InputEmailFrom v-model="mail.from" />
          <div v-if="errors.from">
            <p class="text-danger">
              {{ errors.from[0] }}
            </p>
          </div>
          <p class="small-text f-w-500 color-gray-light my-2">
            {{ __('Somente domínio verificados são aceitos.') }}
            <a
              class="color-gray-light"
              href="/settings/#/domains"
              target="_blank"
            >{{ __('Clique aqui') }}</a> {{ __('para ver seus domínios.') }}
          </p>
        </div>
        <div class="form-group">
          <label>{{ __('Responder e-mail para') }}</label>
          <input
            class="form-control"
            type="email"
            v-model="mail.reply_to"
            :placeholder="__('Responder e-mail para')"
          >
          <p class="small-text f-w-500 color-gray-light my-2">
            {{ __('Deixe em branco para responder para o remetente') }}
          </p>
        </div>
        <div class="form-group">
          <label>{{ __('Categorias') }}</label>
          <InputCategory
            type="mail"
            :value="mail.categories"
            :model="mail.id"
          />
        </div>
        <!-- eslint-enable-->
        <div class="modal-footer default-modal-footer">
          <button
            class="btn btn-primary f-w-500"
            type="submit"
            :disabled="saving"
          >
            <i
              class="fa fa-circle-o-notch fa-spin"
              v-if="saving"
            /><span v-else>{{ __('Continuar') }}</span>
          </button>
        </div>
      </form>
    </template>
  </BModal>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['user', 'mail'],

  mounted () {
    Bus.$on('modalConfigToggled', () => this.open());
  },

  data () {
    return {
      saving: false,
      from: null,
      errors: {},
    };
  },

  methods: {
    open () {
      this.$refs['modal-config-mail'].show();
    },

    close () {
      this.$refs['modal-config-mail'].hide();
    },

    save () {
      this.errors = {};

      this.saving = true;

      const update = {
        title: this.mail.title,
        subject: this.mail.subject,
        from_name: this.mail.from_name,
        from: this.mail.from,
        reply_to: this.mail.reply_to,
      };

      this.$http.put(`/mail/${this.mail.id}`, update)
        .then(() => {
          this.saving = false;

          this.$refs['modal-config-mail'].hide();

          Alert.success(this.__('Configurações salvas!'));
        })
        .catch((response) => {
          this.saving = false;

          if (response.status === 422) {
            this.errors = response.data;
          }
        });
    },
  },
};
</script>
